// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RT-z","hovered":"ST-z","hoverImage":"TT-z","mainImage":"UT-z","imageNoBackground":"VT-z","fullSizeImage":"WT-z"};